import axios from '@/plugins/axios/https';

export function ApiDataGenerationAll() {
  return axios.post('/data_generation/generate-all/');
}

export function ApiDataGenerationCampaigns() {
  return axios.post('/data_generation/generate-campaigns/');
}

export function ApiDataGenerationClientbases() {
  return axios.post('/data_generation/generate-clientbases/');
}

export function ApiDataGenerationFiltrations() {
  return axios.post('/data_generation/generate-filtrations/');
}

export function ApiDataGenerationTags() {
  return axios.post('/data_generation/generate-tags/');
}
